<template>
  <b-modal
    v-model="mdlShow"
    :title="taskObj.loaded ? taskObj.task.task : 'Түр хүлээнэ үү...'"
    scrollable
    fullscreen
    hide-footer
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <div v-if="taskObj != null">
      <div
        class="content-area pa-2"
        v-if="taskObj.task != null && taskObj.task.taskDesc != null"
        v-html="taskObj.task.taskDesc.replace('<embed', '<iframe')"
      ></div>
    </div>
    <!-- <v-card>
    <v-card-text style="height: 100vh;" class="pa-0" v-if="taskObj!=null">
      <div class="content-area pa-2" v-if="taskObj.task!=null && taskObj.task.taskDesc!=null" v-html="taskObj.task.taskDesc.replace('<embed','<iframe')"></div>
    </v-card-text>
    </v-card> -->
  </b-modal>
</template>

<script>
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";
import { taskInheritedDetail } from "@/api/task";

export default {
  name: "TaskDetailOnDialog",
  components: {
    // taskDetail: () => ({
    //   component: import("@/components/task/detail/default.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
  },
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    show: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      mdlShow: false,
      taskObj: {
        loaded: false,
        columns: [],
        task: {}
      },
      pages: []
    };
  },
  mounted() {
    //this.init();
  },
  methods: {
    init() {
      taskInheritedDetail({ params: { id: this.id }, store: this.$store }).then(
        res => {
          if (res != false) {
            //console.log(this.id);
            this.taskObj.task = res.data.task;
            this.taskObj.columns = res.data.columns;
            this.taskObj.loaded = true;

            let pid = this.taskObj.task.organizationTaskId;
            if (pid != null) {
              this.pages = this.$store.state.app.pages.filter(
                x => x.i2 == 1 && x.parentId == pid
              );
            }

            this.mdlShow = true;
          }
        }
      );
    },
    clearObj() {
      this.mdlShow = false;
      this.taskObj.loaded = false;
      this.taskObj.columns = [];
      this.taskObj.task = {};
    }
  },
  computed: {
    taskId() {
      return this.id;
    }
  },
  watch: {
    taskId(val) {
      if (val > 0) {
        this.init();
      }
    }
  }
};
</script>

<style>
.content-area img,
.content-area iframe {
  max-width: 100%;
  height: auto !important;
}
</style>
